import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { TENANT } from '../constants/routeConstants';

export function TenantIdentityConfirmation() {
  const history = useHistory();

  useEffect(() => {
    history.replace(`${TENANT.WELCOME}${window.location.search}`);
  }, [history]);

  return (
    <></> //Deprecating page, redirect to welcome page
  );
}

export default TenantIdentityConfirmation;
